import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

export default function Privacy() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Shutdown Intercom if it exists
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            Privacy Policy
          </h1>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-sm text-gray-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

            <p className="mb-6">
              Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
            <h3 className="text-lg font-semibold mt-6 mb-3">1.1 Personal Information</h3>
            <p className="mb-4">We collect information that you provide directly to us:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Account information (email address, name)</li>
              <li>Company details (if provided)</li>
              <li>Event participant data that you upload</li>
            </ul>

            <h3 className="text-lg font-semibold mt-6 mb-3">1.2 Usage Information</h3>
            <p className="mb-4">We automatically collect certain information about your device and how you interact with our services:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Log data (IP address, browser type, pages visited)</li>
              <li>Device information (operating system, unique device identifiers)</li>
              <li>Usage patterns and preferences</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Provide and maintain our services</li>
              <li>Process and display event results</li>
              <li>Improve and optimize our platform</li>
              <li>Communicate with you about your account or our services</li>
              <li>Detect and prevent fraud or abuse</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Data Sharing and Disclosure</h2>
            <p className="mb-4">We may share your information in the following circumstances:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent abuse</li>
              <li>In connection with a business transfer or merger</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Data Security</h2>
            <p className="mb-6">
              We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to our processing of your data</li>
              <li>Withdraw consent where applicable</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Data Retention</h2>
            <p className="mb-6">
              We retain your information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy. When we no longer need to use your information, we will securely delete or anonymize it.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Changes to This Policy</h2>
            <p className="mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Contact Us</h2>
            <p className="mb-6">
              If you have any questions about this Privacy Policy or our practices, please contact us at privacy@pacerapp.co.uk.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}